import React, { useState } from 'react';
import './About.css';
import ReviewDialog from '../../components/ReviewDialog/ReviewDialog';

const About = ({ isLoggedIn, user }) => {
  const [showReviews, setShowReviews] = useState(false);

  const values = [
    {
      id: 1,
      icon: (
        <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      ),
      title: 'Security First',
      description: 'We prioritize your safety with cutting-edge surveillance technology and secure communication systems backed by comprehensive warranties.'
    },
    {
      id: 2,
      icon: (
        <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      ),
      title: 'Global Standards',
      description: 'Using enterprise-grade equipment and international security protocols, we ensure every installation meets global industry standards.'
    },
    {
      id: 3,
      icon: (
        <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="6" />
          <circle cx="12" cy="12" r="2" />
        </svg>
      ),
      title: 'Technical Expertise',
      description: 'Our certified professionals bring deep technical knowledge in surveillance, NVR systems, and secure communications to every project.'
    },
    {
      id: 4,
      icon: (
        <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: 'Trusted Partnership',
      description: 'Your security is our mission. We build long-term partnerships by delivering reliable solutions that protect what matters most.'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="page-title fade-in">About Transcontinental Network</h1>
          <p className="page-subtitle fade-in">
            Your trusted security technology partner providing professional surveillance and communication solutions since 2018
          </p>
          {/* ✅ NEW - View Reviews Button */}
          <button
            className="view-reviews-btn"
            onClick={() => setShowReviews(true)}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" className="star-icon" style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            View Customer Reviews
          </button>
        </div>
      </section>

      {/* Company Story */}
      <section className="company-story section">
        <div className="container">
          <div className="story-content">
            <div className="story-text slide-in-left">
              <h2 className="section-title">Our Security Mission</h2>
              <p>
                Founded in 2018, Transcontinental Network began with a focused mission: to provide cutting-edge
                security surveillance systems, network video recorders, and professional communication solutions
                to businesses and organizations worldwide. What started as a specialized team of security technicians
                has evolved into a comprehensive security technology provider trusted by enterprises across multiple continents.
              </p>
              <p>
                We specialize in designing and implementing robust security infrastructures using the latest in
                camera technology, NVR systems, and secure communication networks. Our commitment to excellence
                and security-first approach has established us as the premier choice for organizations that demand
                the highest levels of protection and reliability.
              </p>
              <div className="story-stats">
                <div className="stat-item">
                  <span className="stat-number">6+</span>
                  <span className="stat-label">Years Securing Networks</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Security Installations</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <span className="stat-label">Monitoring Support</span>
                </div>
              </div>
            </div>
            <div className="story-image slide-in-right">
              <img
                src="https://images.unsplash.com/photo-1558002038-1055907df827?w=500&h=400&fit=crop"
                alt="Our Security Systems Installation"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section section">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <p className="section-subtitle">
            The security principles that guide everything we do
          </p>

          <div className="grid-4">
            {values.map((value) => (
              <div key={value.id} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ NEW - Review Dialog */}
      <ReviewDialog
        isOpen={showReviews}
        onClose={() => setShowReviews(false)}
        isLoggedIn={isLoggedIn}
        user={user}
      />
    </div>
  );
};

export default About;